// Utilitaires pour la validation et la sécurité des données

export const validateUUID = (uuid: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};

export const validateUserSession = (user: any): user is { id: string } => {
  return user && user.id && validateUUID(user.id);
};

export const sanitizeText = (text: string): string => {
  if (!text || typeof text !== 'string') return '';
  return text.trim().slice(0, 10000); // Limite à 10k caractères
};

export const sanitizeQuery = (query: string): string => {
  if (!query || typeof query !== 'string') return '';
  // Enlever caractères potentiellement dangereux
  return query.replace(/[<>\"']/g, '').trim().slice(0, 1000);
};

export const createSafeError = (message: string, code?: string) => {
  return {
    message: sanitizeText(message),
    code: code || 'UNKNOWN_ERROR',
    timestamp: new Date().toISOString()
  };
};